import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { LAXIMO_TOKENS_EXHAUSTED_ERROR_CODE } from '../models/laximo-tokens.constants';
import { LaximoValidationErrorBody } from '../models/laximo-validation-error.interface';

function isValidationErrorBody(body: unknown): body is LaximoValidationErrorBody {
  return typeof body === 'object' && body !== null && 'errors' in body;
}

/** The BFF blocks a token-charged request with 400 and `errors[].errorCode = LaximoTokensExhausted` (not 403: it logs the user out). */
export function isLaximoTokensExhaustedError(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse) || error.status !== HttpStatusCode.BadRequest || !isValidationErrorBody(error.error)) {
    return false;
  }

  return (error.error.errors ?? []).some(failure => failure?.errorCode === LAXIMO_TOKENS_EXHAUSTED_ERROR_CODE);
}
